import styled from "styled-components";

export const Label = styled.span`
  color: ${props => props.theme.colors.silverChumbo};
  font-size: .75rem;
`